import React from "react";
import { OFFER_ANCHOR } from "../utils/checkout";
import { BrandLogo } from "./BrandLogo";
import { useLocalizedPrices } from "../hooks/useLocalizedPrices";
export function SiteHeader() {
  const {
    mainPrice
  } = useLocalizedPrices();
  return <header className="sticky top-0 z-40 border-b border-cream-50/10 bg-cocoa-950/95 backdrop-blur" data-id="element-270" data-mp="1nm4rp7jw2deb">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5" data-id="element-271" data-mp="1ipwjyf80tmh6">
        <a href="#inicio" aria-label="Aura Content — inicio" className="text-[15px] sm:text-base" data-id="element-272" data-mp="uyr1rtelyi3p">
          <BrandLogo data-id="element-273" data-mp="qy8dg9bxbu69" />
        </a>
        <nav aria-label="Secciones" className="hidden items-center gap-7 text-sm text-cream-200 lg:flex" data-id="element-274" data-mp="14wf1yyuzght9">
          <a href="#volumenes" className="transition-colors duration-150 hover:text-cream-50" data-id="element-275" data-mp="zxlm4zs84epx">Volúmenes</a>
          <a href="#bonos" className="transition-colors duration-150 hover:text-cream-50" data-id="element-276" data-mp="2gb2bxg7nuk9p">Bonos</a>
          <a href="#plan" className="transition-colors duration-150 hover:text-cream-50" data-id="element-277" data-mp="2bd0h5y0vgwie">Plan de 30 días</a>
          <a href="#preguntas" className="transition-colors duration-150 hover:text-cream-50" data-id="element-278" data-mp="29kbvfpz854tt">Preguntas</a>
        </nav>
        <a href={OFFER_ANCHOR} className="hidden rounded-full border border-caramel-400 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-caramel-300 transition-colors duration-150 hover:bg-caramel-500 hover:text-cocoa-950 sm:inline-flex" data-id="element-279" data-mp="2ehlpxk1h06oi">
          Empezar · {mainPrice}
        </a>
      </div>
    </header>;
}